<div class="container w-11/12 h-full mt-4 max-w-7xl mx-auto flex flex-col">
  <ng-container *ngIf="{ data: authors | async } as obs">
    <ng-container *ngIf="!(isFirstLoad || isPaginating); else loadingTpl">
      <div
        class="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden w-full"
        *ngIf="total > 0"
      >
        <ng-container *ngIf="obs.data as response">
          <table
            mat-table
            [dataSource]="response.data"
            matSort
            matSortActive="publication_date"
            matSortDisableClear
            matSortDirection="desc"
          >
            <!-- Title Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef class="text-center">Name</th>
              <td mat-cell *matCellDef="let row">{{ row.name }}</td>
            </ng-container>

            <ng-container matColumnDef="current_affiliation">
              <th mat-header-cell *matHeaderCellDef class="text-center">Affiliation</th>
              <td mat-cell *matCellDef="let row" class="text-center">
                {{ row.current_affiliation }}
              </td>
            </ng-container>

            <ng-container matColumnDef="articles">
              <th mat-header-cell *matHeaderCellDef class="text-center">Articles</th>
              <td mat-cell *matCellDef="let row" class="text-center">
                {{ row.articles === 0 ? '-' : row.articles }}
              </td>
            </ng-container>

            <ng-container matColumnDef="topics">
              <th mat-header-cell *matHeaderCellDef class="text-center">Topics</th>
              <td mat-cell *matCellDef="let row" class="text-center">
                {{ row.topics === 0 ? '-' : row.topics }}
              </td>
            </ng-container>

            <ng-container matColumnDef="affiliations">
              <th mat-header-cell *matHeaderCellDef class="text-center">Affiliations</th>
              <td mat-cell *matCellDef="let row" class="text-center">
                {{ row.affiliations === 0 ? '-' : row.affiliations }}
              </td>
            </ng-container>

            <ng-container matColumnDef="citation_count">
              <th mat-header-cell *matHeaderCellDef class="text-center">Citations</th>
              <td mat-cell *matCellDef="let row" class="text-center">
                {{ row.citation_count === 0 ? '-' : row.citation_count }}
              </td>
            </ng-container>

            <ng-container matColumnDef="updated">
              <th mat-header-cell *matHeaderCellDef class="text-center">Status</th>
              <td class="" mat-cell *matCellDef="let row">
                <ng-container *ngIf="row.updated">
                  <div class="flex justify-center items-center">
                    <div class="bg-green-300 text-center rounded-full w-3 h-3"></div>
                  </div>
                </ng-container>
                <ng-container *ngIf="!row.updated">
                  <div class="flex justify-center items-center">
                    <div
                      class="bg-orange-200 text-center rounded-full w-3 h-3"
                      matTooltip="This author have not been updated from admin site"
                    ></div>
                  </div>
                </ng-container>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              class="hover:cursor-pointer hover:bg-gray-200"
              (click)="goToAuthor(row.scopus_id)"
            ></tr>
          </table>
        </ng-container>
      </div>
    </ng-container>

    <ng-template #loadingTpl>
      <div class="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden w-full">
        <app-loader [rows]="10"></app-loader>
      </div>
    </ng-template>

    <!-- Pagination and Indicator -->
    <div
      class="flex flex-col sm:flex-row items-center justify-end px-4 py-2 bg-white mt-4 rounded-xl shadow-md border border-gray-200"
      *ngIf="total > 0"
    >
      <div class="text-sm text-gray-600 font-medium mr-4 flex items-center">
        <app-mini-loader *ngIf="isPaginating" class="mr-2"></app-mini-loader>
        Current Page: <span class="text-red-700 font-bold ml-1">{{ page }}</span>
      </div>
      <mat-paginator
        [length]="total"
        [pageSize]="size"
        [pageIndex]="page - 1"
        [pageSizeOptions]="[5, 10, 25, 100]"
        aria-label="Select page"
        (page)="onChangePagination($event)"
      >
      </mat-paginator>
    </div>
  </ng-container>
  <ng-container *ngIf="!(isFirstLoad || isPaginating) && total === 0">
    <app-no-results [isServerOnline]="isServerOnline" title="No results found"></app-no-results>
  </ng-container>
</div>
